var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActiveQuestionLime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "var(--fill-color, #ECFF92)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#283333",
    fillRule: "nonzero",
    d: "M9.868 11v-.264c0-.348.096-.54.432-.852l.72-.66c.42-.384.828-1.092.828-1.8C11.848 5.6 10.576 5 9.424 5S7 5.6 7 7.424v.096h.9v-.108c0-1.032.72-1.548 1.524-1.548s1.524.516 1.524 1.548c0 .54-.324 1.008-.564 1.236l-.72.66c-.48.444-.696.768-.696 1.428V11h.9zm.192 2.52v-1.26H8.8v1.26h1.26z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActiveQuestionLime);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjkiIGZpbGw9InZhcigtLWZpbGwtY29sb3IsICNFQ0ZGOTIpIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzI4MzMzMyIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNOS44NjggMTF2LS4yNjRjMC0uMzQ4LjA5Ni0uNTQuNDMyLS44NTJsLjcyLS42NmMuNDItLjM4NC44MjgtMS4wOTIuODI4LTEuOEMxMS44NDggNS42IDEwLjU3NiA1IDkuNDI0IDVTNyA1LjYgNyA3LjQyNHYuMDk2aC45di0uMTA4YzAtMS4wMzIuNzItMS41NDggMS41MjQtMS41NDhzMS41MjQuNTE2IDEuNTI0IDEuNTQ4YzAgLjU0LS4zMjQgMS4wMDgtLjU2NCAxLjIzNmwtLjcyLjY2Yy0uNDguNDQ0LS42OTYuNzY4LS42OTYgMS40MjhWMTFoLjl6bS4xOTIgMi41MnYtMS4yNkg4Ljh2MS4yNmgxLjI2eiIvPgogICAgPC9nPgo8L3N2Zz4K";